import styled from 'styled-components';
import { Box } from '@chakra-ui/react'

export const BoxWrapper = styled(Box)`
    margin-left: auto;
    margin-right: auto;
`
export const BarDivider = styled.div`
    width: 4rem;
    background: #787A91;
    height: 2px;
    opacity: .5;
    
`